import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntTypeAnimal } from "../../../../models/handBooks/typeAnimal";
import { useAddAnimalTypeMutation, useDeleteAnimalTypeMutation, useEditAnimalTypeMutation } from "../../../../redux/api/handBooksApi/animalTypesApi";
import { getCookie } from "typescript-cookie";



const useTypeAnimal = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addTypeAnimal] = useAddAnimalTypeMutation();
    const [deleteTypeAnimal] = useDeleteAnimalTypeMutation();
    const [editTypeAnimal] = useEditAnimalTypeMutation();


    async function onAddTypeAnimal(newTypeAnimal: EntTypeAnimal): Promise<boolean> {
        try {
            let status: boolean = false;
            await addTypeAnimal(newTypeAnimal).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error:any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
          
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }
    async function onDeleteTypeAnimal(typeAnimal: EntTypeAnimal) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteTypeAnimal(typeAnimal.id).then((response: any) => {
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({title: t('msg.successDelete')});
                            if(refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                        
                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    async function onEditTypeAnimal(editedTypeAnimal: EntTypeAnimal): Promise<boolean> {
        try {
            let status: boolean = false;
            await editTypeAnimal(editedTypeAnimal).then((response: any) => {
                  if (response.error) {
                                              const isKyrgyz = getCookie('i18next') === 'ky';
                                              const lang = isKyrgyz ? 'kg' : 'ru';
                                              const res = response.error.data?.res;
                                              const errorMessages = Array.isArray(res)
                                                  ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                  : response.error.data?.msg || t('unknownError'); 
                                              throw new Error(errorMessages);
                                          }
                if (response.data.success) {
                    status = true;
                    Modal.success({title: t('msg.successEdited')});
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    return { onAddTypeAnimal,onDeleteTypeAnimal, onEditTypeAnimal }

}
export { useTypeAnimal };

